// extracted by mini-css-extract-plugin
export default {"menuSliderContainer":"style_menuSliderContainer__CevJT"};